// extracted by mini-css-extract-plugin
var _1 = "styles-module__container____fhPo";
var _2 = "styles-module__controlBtns___WqEfD";
var _3 = "styles-module__coordinates___ZrOM2";
var _4 = "styles-module__description___NYCmm";
var _5 = "styles-module__linkBtnContainer___KVza4";
var _6 = "styles-module__nameAndDescription___c3PpX";
var _7 = "styles-module__title___aaDpf";
export { _1 as "container", _2 as "controlBtns", _3 as "coordinates", _4 as "description", _5 as "linkBtnContainer", _6 as "nameAndDescription", _7 as "title" }
